import { useSelector } from 'react-redux';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Iconify from '../../../components/iconify/Iconify';
import SvgColor from '../../../components/svg-color';
import { isBoscCompany, isStakeholder, isWfhCompany } from '../../../utils/share';
// import { BOSC_ID } from '../../../utils/envVariables';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const NavConfig = () => {
  const accountData = useSelector((state) => state?.login?.user || null);
  const userIsStakeholder = isStakeholder();
  const userIsBoscCompany = isBoscCompany();
  const userIsWfhCompany = isWfhCompany();
  // const companyId = accountData?.companyId;

  // const hideHolidayTab = companyId !== BOSC_ID;
  // const hideQuarterGoalTab = companyId !== BOSC_ID;
  return [
    {
      title: 'Project Dashboard',
      path: '/project-dashboard',
      icon: icon('project-20'),
      permission: 'PROJECT_DASHBOARD',
    },
    {
      title: 'Task dashboard',
      path: '/dashboard',
      icon: icon('ic_analytics'),
      permission: 'CONTENT_DASHBOARD',
    },
    {
      title: 'Time Tracker ',
      path: '/timetracker',
      icon: <Iconify icon={'ic:twotone-access-time'} />,
      permission: 'RUN_TIMETRACKER',
    },
    {
      title: userIsStakeholder ? 'Issues Register' : 'My Task',
      path: userIsStakeholder ? '/mytask/table' : '/mytask',
      icon: <Iconify icon={'material-symbols:task-rounded'} />,
      permission: 'READ_TASK',
    },
    {
      title: 'Timeline',
      path: '/timeline',
      icon: <Iconify icon={'material-symbols:timeline'} />,
      permission: 'RUN_TIMETRACKER',
    },
    {
      title: 'Report',
      path: '/report',
      icon: <Iconify icon={'heroicons-outline:document-report'} />,
      permission: 'READ_REPORT',
    },
    {
      title: 'Projects',
      path: '/projects',
      icon: <Iconify icon={'ant-design:project-filled'} />,
      permission: 'READ_PROJECT',
      // children: [
      //   {
      //     title: 'Archive',
      //     path: '/projects/archive',
      //     icon: <Iconify icon={'ant-design:file-unknown'} />,
      //   },
      //   {
      //     title: 'Active',
      //     path: '/projects/active',
      //     icon: <Iconify icon={'ant-design:thunderbolt-filled'} />,
      //   },
      //   {
      //     title: 'Complete',
      //     path: '/projects/complete',
      //     icon: <Iconify icon={'ant-design:check-circle-filled'} />,
      //   },
      // ],
    },
    {
      title: 'Clients',
      path: '/clients',
      icon: <Iconify icon={'mdi:company'} />,
      permission: 'CREATE_CLIENT',
    },
    {
      title: 'Users',
      path: '/users',
      icon: <Iconify icon={'clarity:employee-solid'} />,
      permission: 'READ_USER',
    },
    {
      title: 'Team',
      path: '/team',
      icon: <Iconify icon={'fluent:people-team-20-filled'} />,
      permission: 'READ_TEAM',
    },
    {
      title: 'My requests',
      icon: <Iconify icon={'material-symbols:folder-managed'} />,
      permission: 'READ_LEAVE',
      children: [
        {
          title: 'Leaves',
          path: '/leaves',
          icon: <Iconify icon={'material-symbols:event-available'} />,
          permission: 'READ_LEAVE',
        },
        {
          title: 'WFH',
          path: '/wfh',
          icon: <Iconify icon={'material-symbols:home-work'} />,
          permission: 'READ_WFH',
          hide: !userIsWfhCompany,
        },
        {
          title: 'Comp-Off',
          path: '/comp-off',
          icon: <Iconify icon={'material-symbols:event-repeat'} />,
          permission: 'READ_COMP_OFF',
          hide: !userIsBoscCompany,
        },
        {
          title: 'Reimbursements',
          path: '/reimbursements',
          icon: <Iconify icon={'material-symbols:receipt-long'} />,
          permission: 'READ_REIMBURSEMENT',
          hide: !userIsBoscCompany,
        },
      ],
    },
    {
      title: 'Escalations',
      path: '/escalations',
      icon: <Iconify icon={'material-symbols:warning-rounded'} />,
      permission: 'READ_ESCALATION',
    },
    {
      title: 'Assets',
      path: '/assets',
      icon: <Iconify icon={'material-symbols:inventory-2'} />,
      permission: 'READ_USER',
    },
    {
      title: 'Admin',
      icon: <AdminPanelSettingsIcon />,
      path: '/admin/developer-scorecard',
      permission: 'READ_USER',
      hide: !userIsBoscCompany,
      children: [
        // {
        //   title: 'Employees Timeline',
        //   path: '/admin/employees-timeline',
        //   icon: <Iconify icon={'mdi:timeline-clock-outline'} />,
        // },
        {
          title: 'Team Scorecard',
          path: '/admin/developer-scorecard',
          icon: <Iconify icon={'mdi:account-star-outline'} />,
        },
      ],
    },
    // {
    //   title: 'Holiday List',
    //   path: '/holiday',
    //   icon: <Iconify icon={'lucide:calendar-days'} />,
    //   hide: hideHolidayTab,
    // },
    // isBOSC() && {
    //   title: 'Weekly Goal',
    //   path: '/weeklygoal',
    //   icon: <Iconify icon={'game-icons:stairs-goal'} />,
    // },
    {
      title: 'Organization',
      icon: <CorporateFareIcon />,
      // path: '/organization/holiday',
      permission: 'READ_CLIENT',
      children: [
        {
          title: 'Holiday List',
          path: '/organization/holiday',
          icon: <Iconify icon={'lucide:calendar-days'} />,
          // hide: hideHolidayTab,
        },
        {
          title: 'Quarterly Goal',
          path: '/organization/quartergoal',
          icon: <Iconify icon={'octicon:goal-16'} />,
          // hide: hideQuarterGoalTab,
        },
      ],
    },
    // {
    //   title: 'Quarterly Goal',
    //   path: '/quartergoal',
    //   icon: <Iconify icon={'octicon:goal-16'} />,
    //   hide: hideQuarterGoalTab,
    // },
    {
      title: 'Release Note',
      path: '/release-notes',
      icon: <Iconify icon={'ic:baseline-description'} />,
      permission: 'READ_CLIENT',
    },
  ].filter(Boolean);
};

export default NavConfig;
